import React, { Fragment, useEffect, useState } from "react";
import {
  AsyncCallArgs,
  BlockText,
  CircularLoader,
  GridContainer,
  HtmlParseText,
  useAsyncCall,
} from "@duosoftbg/nacid-components";
import { ViewDialog } from "@duosoftbg/nacid-components";
import { getEmailTemplate } from "../../../../../../axios/api/services";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { closeModal } from "../../../../../../store/redux/slice/ComponentsControl/emailTemplatesControl";

const ViewEmailTemplateDialog = () => {
  const dispatch = useAppDispatch();
  const { asyncCall } = useAsyncCall();
  const [template, setTemplate] = useState(null);

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.emailTemplatesControl.modals.view;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "view" }));
  };

  useEffect(() => {
    if (open && id != null) {
      const asyncCallArgs: AsyncCallArgs = {
        promise: getEmailTemplate(id),
        onSuccess: (response) => {
          setTemplate(response);
        },
        onError: () => {
          setTemplate(null);
        },
      };
      asyncCall(asyncCallArgs);
    }
    // eslint-disable-next-line
  }, [id, open]);

  return (
    <ViewDialog open={open} onClose={handleCloseDialog} title={"t.email.template.view.dialog"}>
      {!template && <CircularLoader />}
      {template && (
        <Fragment key={template.id + " content"}>
          <GridContainer spacing={4}>
            <BlockText withGrid label={"l.email.template.id"} text={template.id} />
            {template.name && <BlockText withGrid label={"l.email.template.name"} text={template.name} />}
            {template.nameEn && <BlockText withGrid label={"l.email.template.nameEn"} text={template.nameEn} />}
            {template.subject && <BlockText withGrid label={"l.email.template.subject"} text={template.subject} />}
            {template.createdDate && (
              <BlockText withGrid label={"l.email.template.createdDate"} text={template.createdDate} />
            )}
            {template.lastUpdateDate && (
              <BlockText withGrid label={"l.email.template.lastUpdateDate"} text={template.lastUpdateDate} />
            )}
            {template.userCreate && (
              <BlockText withGrid label={"l.email.template.userCreate"} text={template.userCreate} />
            )}
            {template.userLastUpdate && (
              <BlockText withGrid label={"l.email.template.userLastUpdate"} text={template.userLastUpdate} />
            )}
            {template.params && (
              <HtmlParseText
                withGrid={true}
                propsGrid={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                text={template.params}
                label={"l.email.template.params"}
                styleArray={{ pointerEvents: "none" }}
              />
            )}
            {template.text && !template.isHtml && (
              <BlockText withGrid label={"l.email.template.text"} text={template.text} />
            )}
            {template.text && template.isHtml && (
              <HtmlParseText
                withGrid={true}
                propsGrid={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                text={template.text}
                label={"l.email.template.text"}
                styleArray={{ pointerEvents: "none" }}
              />
            )}
          </GridContainer>
        </Fragment>
      )}
    </ViewDialog>
  );
};

export default ViewEmailTemplateDialog;
